import { createSlice } from '@reduxjs/toolkit';

import {
    DOWNLOAD_CSV,
    DOWNLOAD_CSV_FAILURE,
    DOWNLOAD_CSV_SUCCESS,
    FETCH_COMPANIES,
    FETCH_COMPANIES_FAILURE,
    FETCH_COMPANIES_SUCCESS,
    FECH_COUNTRIES,
    FECH_COUNTRIES_FAILURE,
    FECH_COUNTRIES_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    companies: {
        data: {
            data: [],
            paginaton: {},
        },
        error: null,
        isFetching: false,
    },
    countries: {
        data: [],
        errors: [],
        isFetching: false,
    },
    downloadCSV: {
        isFetching: false,
        data: null,
        errors: [],
    },
};

const companiesSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [DOWNLOAD_CSV]: (state) => {
            state.downloadCSV = {
                ...state.downloadCSV,
                errors: [],
                isFetching: true,
            };
        },
        [DOWNLOAD_CSV_FAILURE]: (state, action) => {
            state.downloadCSV = {
                ...state.downloadCSV,
                errors: action.payload,
                isFetching: false,
            };
        },
        [DOWNLOAD_CSV_SUCCESS]: (state, action) => {
            state.downloadCSV = {
                ...state.downloadCSV,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_COMPANIES]: (state) => {
            state.companies = {
                ...state.companies,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_COMPANIES_FAILURE]: (state, action) => {
            state.companies = {
                ...state.companies,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_COMPANIES_SUCCESS]: (state, action) => {
            state.companies = {
                ...state.companies,
                data: action.payload,
                isFetching: false,
            };
        },
        [FECH_COUNTRIES]: (state) => {
            state.countries = {
                ...state.countries,
                errors: [],
                isFetching: true,
            };
        },
        [FECH_COUNTRIES_FAILURE]: (state, action) => {
            state.countries = {
                ...state.countries,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FECH_COUNTRIES_SUCCESS]: (state, action) => {
            state.countries = {
                ...state.countries,
                data: action.payload,
                errors: [],
                isFetching: false,
            };
        },
    },
});

export const companiesActions = companiesSlice.actions;

export default companiesSlice.reducer;
